import React from 'react';
import { Item } from '@radix-ui/react-toggle-group';
import { twMerge } from 'tailwind-merge';

export const ToggleItem = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
} & React.ComponentProps<typeof Item>) => {
  return (
    <Item
      className={twMerge(
        'rounded-full px-2 py-1.5 font-base text-base-s font-semibold data-[state=on]:bg-white data-[state=off]:text-base400 data-[state=on]:text-base800 hover:shadow-tertiary',
        className,
      )}
      {...props}
    >
      {children}
    </Item>
  );
};
